export default __webpack_public_path__ + "src/assets/trezor.5b157924c9a10dd04fe08994ed34cbff.svg";